import { Paper, styled, SxProps, Typography } from '@mui/material';
import { colors } from './AMBGTheme';

export const StyledAuthTitle = styled(Typography)({
	fontSize: '24px',
	fontWeight: '700',
	textAlign: 'center',
	marginTop: '30px',
	marginBottom: '40px',
	color: colors.primary.main,
	'@media (max-height: 700px)': {
		margin: '10px 0'
	}
}) as typeof Typography;

export const StyledAuthContainer = styled(Paper)({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	width: '100%',
	maxWidth: '400px',
	padding: '20px 40px 40px',
	borderRadius: '16px',
	'@media (max-height: 650px)': {
		padding: '20px'
	}
}) as typeof Paper;

export const CommonLinkSxProps = {
	fontSize: '12px',
	marginTop: '16px',
	alignSelf: 'end',
	display: 'flex',
	alignItems: 'center',
	gap: '5px',
	cursor: 'pointer',
	'&:hover': {
		textDecoration: 'underline'
	}
} as SxProps;

export const mainBox = {
	margin: '15px',
	boxShadow: `0px 5px 7px -1px ${colors.boxShadowColor}`,
	borderBottom: `1px solid ${colors.borderColor}`,
	backgroundColor: colors.white.main,
	borderRadius: '20px',
	padding: '15px'
} as SxProps;

export const tableTitleBox = {
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	marginBottom: '10px'
} as SxProps;

export const btnGroupBox = {
	display: 'flex',
	alignItems: 'center',
	gap: '10px',
	flexWrap: 'wrap',
	justifyContent: 'flex-end'
} as SxProps;

export const tableTitle = {
	fontSize: '15px',
	fontWeight: 500,
	color: colors.secondary.shade7
} as SxProps;

export const actionBox = {
	display: 'flex',
	alignItems: 'center'
} as SxProps;

export const lightPrimaryBtn = {
	backgroundColor: colors.primary.shade4,
	color: colors.primary.main,
	':hover': {
		backgroundColor: colors.primary.shade4,
		color: colors.primary.main
	}
} as SxProps;

export const formBox = {
	margin: '25px',
	boxShadow: `0px 5px 7px -1px ${colors.boxShadowColor}`,
	borderBottom: `1px solid ${colors.borderColor}`,
	backgroundColor: colors.white.main,
	borderRadius: '20px',
	padding: '32px',
	width: '100%',
	height: '100%',
	alignItems: 'center',
	display: 'flex',
	flexDirection: 'column',
	maxWidth: '730px'
} as SxProps;

export const filteredChipRoot = {
	gap: '7px',
	display: 'flex',
	alignItems: 'center',
	marginBottom: '10px'
};

export const iconButton = {
	' & .MuiSvgIcon-root:hover': {
		fill: colors.primary.main
	}
};

export const boxWithColumns = { display: 'flex', gap: '20px' };

export const excelUploadErrorBox = {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'start',
	justifyContent: 'center',
	marginBottom: '20px',
	gap: '5px'
} as SxProps;

export const errorTableTitle = {
	fontSize: '15px',
	marginLeft: '10px',
	color: colors.primary.main
} as SxProps;
